<template lang="html">
  <div>
    <van-overlay :show="overlayShow" @click="overlayShow = false">
      <div class="wrapper">
        <div class="block">
          <p style="padding-left:16px">第一步：<strong>点右上角的 <van-icon name="ellipsis" size="26px" style="margin-left:5px;color:#000;"/></strong><br><br>第二步：<strong>点“发送给朋友”</strong></p>
        </div>
      </div>

    </van-overlay>
    <van-cell-group title="">
      <van-cell>
        <div style="text-align:center;padding-top:25px;">
          <van-image
            round
            width="50px"
            height="50px"
            :src="giftCard.sender.wechat_profile.headimgurl"
          />
          <p>好友{{giftCard.sender.wechat_profile.nickname}}送你一节私房课</p>
          <van-divider>赠言</van-divider>
          <blockquote>
            {{invitation.note}}
          </blockquote>
        </div>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="margin-top:10px">
      <van-cell>
        <EpisodeCard
          :click-disabled="true"
          :compact="true"
          :showDescription="false"
          :showRating="false"
          :showPubtime="false"
          :episodeId="giftCard.object_id"
        />
      </van-cell>
    </van-cell-group>
    <div v-if="this.invitation.action" style="margin-top:20px;text-align:center;">
      <van-button
        round
        type="primary"
        @click="action"
        :loading="actionLoading || shareInfoLoading"
        :disabled="actionLoading || shareInfoLoading"
        style="width:130px"
      >{{actionLabel}}</van-button>
    </div>
    <div v-else>
      <van-cell-group
        v-if="invitation.receiver"
        style="margin-top:10px"
      >
        <van-cell
          :icon="invitation.receiver.wechat_profile.headimgurl"
          :title="invitation.receiver.wechat_profile.nickname"
          value="已接受"
        >
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
const wx = require('weixin-js-sdk')
import Vue from 'vue'
import { Divider } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Overlay } from 'vant'
import { Notify } from 'vant'
import EpisodeCard from './episode-card.vue'
Vue.use(Divider)
Vue.use(Cell).use(CellGroup)
Vue.use(Overlay)
Vue.use(Notify)
export default {
  name: 'invitation-detail',
  components: {
    EpisodeCard
  },
  data () {
    return {
      overlayShow: false,
      actionLoading: false,
      shareInfoLoading: true,
      invitation: {
        giftcard: 0,
        receiver: null,
        note: "",
        used: false,
        share_info: {
          title: '',
          desc: '',
          link: '',
          imgUrl: ''
        }
      },
      giftCard: {
        id: 0,
        available_count: 0,
        note: '',
        quota: 0,
        sender: {
          id: 0,
          wechat_profile: {
            city: '',
            country: '',
            gender: 0,
            headimgurl: '',
            language: '',
            nickname: '',
            province: ''
          }
        }
      }
    }
  },
  computed: {
    actionLabel () {
      let label
      let action = this.invitation.action
      if (action == 'send') {
        label = '赠送好友'
      } else if (action == 'receive') {
        label = '接受赠送'
      } else if (action == 'listen') {
        label = '收听'
      }
      return label
    }
  },
  methods: {
    action () {
      let action = this.invitation.action
      if (action == 'send') {
        this.overlayShow = true
      } else if (action == 'receive' || action == 'listen') {
        let that = this
        that.actionLoading = true
        let invitationId = that.invitation.id
        let params = {
          giftcard: that.invitation.giftcard,
          used: true
        }
        that.$api.invitation.update(invitationId, params).then(res => {
          that.actionLoading = false
          window.console.log(res)
          that.$router.push({
            name: 'EpisodeDetail',
            params: {
              episodeId: that.giftCard.object_id
            }
          })
        })
      }
    }
  },
  mounted () {
    let that = this
    // location.reload()
    let params = {url: location.href.split('#')[0]}
    that.$api.libs.getJSApiConfig(params).then(res => {
      // 开始注入微信jsapi权限验证配置
      wx.config({
        debug: false,
        appId: res.data.appid,
        timestamp: res.data.timestamp,
        nonceStr: res.data.noncestr,
        signature: res.data.signature,
        jsApiList: ['updateAppMessageShareData']
      })

      let invitationId = that.$route.params.invitationId
      that.$api.invitation.detail(invitationId).then(res => {
        that.invitation = res.data
        window.console.log(res.data)
        that.$api.giftcard.detail(that.invitation.giftcard).then(res => {
          that.giftCard = res.data
        })
        wx.ready(function(){
          let shareInfo = that.invitation.share_info
          wx.updateAppMessageShareData({
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareInfo.imgUrl, // 分享图标
            success: function () {
              that.shareInfoLoading = false
            }
          })
        })
      })

    })

  }
}
</script>

<style lang="css" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .block {
    position: absolute;
    top:0;
    width: 100%;
    background-color: #fff;
  }
  blockquote {
    font-size: 1.2em;
    font-weight: bold;
  }
</style>
